import React from 'react';
import { Checkbox, Col, ControlLabel, FormControl, HelpBlock, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';
import { get } from '../../../../shared/http/request';
import moment from 'moment';

class SpecialInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            logisticPartners: [],
        };
    }

    componentWillMount() {
        get('/api/reports/logistic-partners').then(
            logisticPartners =>
                this.setState({
                    logisticPartners: logisticPartners.logisticPartnerNames.sort(),
                }),
            error =>
                console.log(
                    '[SpecialInfo] Error while getting logistic partners on mount...',
                    error
                )
        );
    }

    render() {
        const {
            recoveryAction,
            handleChange,
            handleDateChange,
            fields,
            errors,
            isEditable,
            isEditableByGroupAssignee,
        } = this.props;
        const { logisticPartners } = this.state;

        if (!recoveryAction) {
            return <span />;
        }

        const {
            arrivalDate,
            unloadingDate,
            collectionDate,
            carrier,
            trailerIdentifier,
            twoWaySpecial,
        } = fields;
        const { fromLocation, toLocation, impactedRuns } = recoveryAction;

        return (
            <Row>
                <Col sm={4}>
                    <Row>
                        <Col componentClass={ControlLabel} sm={4}>
                            From
                        </Col>
                        <Col sm={8}>{fromLocation || 'N/A'}</Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col componentClass={ControlLabel} sm={4} style={{ marginTop: 8 }}>
                            Collection date
                        </Col>
                        <Col sm={8}>
                            {!isEditable &&
                                !isEditableByGroupAssignee && (
                                    <p style={{ marginTop: 5 }}>
                                        {moment(collectionDate).format('DD-MM-YYYY HH:mm') || '-'}
                                    </p>
                                )}
                            {(isEditable || isEditableByGroupAssignee) && (
                                <Datetime
                                    value={collectionDate}
                                    onChange={handleDateChange('collectionDate')}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat="HH:mm"
                                    inputProps={{ maxLength: 255 }}
                                    className={errors.collectionDate && 'datetime-error'}
                                />
                            )}
                            {errors.collectionDate && (
                                <HelpBlock>
                                    <span className="text-danger">{errors.collectionDate}</span>
                                </HelpBlock>
                            )}
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col componentClass={ControlLabel} sm={4} style={{ marginTop: 8 }}>
                            Carrier
                        </Col>
                        <Col sm={8}>
                            {!isEditable && <p style={{ marginTop: 5 }}>{carrier || '-'}</p>}
                            {isEditable && (
                                <FormControl
                                    name="carrier"
                                    value={carrier}
                                    onChange={handleChange}
                                    componentClass="select"
                                >
                                    <option value="">Select carrier</option>
                                    {logisticPartners.length > 0 &&
                                        logisticPartners.map(lp => (
                                            <option key={lp} value={lp}>
                                                {lp}
                                            </option>
                                        ))}
                                </FormControl>
                            )}
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col componentClass={ControlLabel} sm={4} style={{ marginTop: 8 }}>
                            Trailer number
                        </Col>
                        <Col sm={8}>
                            {!isEditable &&
                                !isEditableByGroupAssignee && (
                                    <p style={{ marginTop: 5 }}>{trailerIdentifier || '-'}</p>
                                )}
                            {(isEditable || isEditableByGroupAssignee) && (
                                <FormControl
                                    name="trailerIdentifier"
                                    type="text"
                                    value={trailerIdentifier}
                                    onChange={handleChange}
                                    maxLength="1000"
                                />
                            )}
                        </Col>
                    </Row>
                </Col>
                <Col sm={4}>
                    <Row>
                        <Col componentClass={ControlLabel} sm={4}>
                            To
                        </Col>
                        <Col sm={8}>{toLocation || 'N/A'}</Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col componentClass={ControlLabel} sm={4} style={{ marginTop: 8 }}>
                            Arrival date *
                        </Col>
                        <Col sm={8}>
                            {!isEditable && (
                                <p style={{ marginTop: 5 }}>
                                    {moment(arrivalDate).format('DD-MM-YYYY HH:mm') || '-'}
                                </p>
                            )}
                            {isEditable && (
                                <Datetime
                                    value={arrivalDate}
                                    onChange={handleDateChange('arrivalDate')}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat="HH:mm"
                                    inputProps={{ maxLength: 255 }}
                                    className={errors.arrivalDate && 'datetime-error'}
                                />
                            )}
                            {errors.arrivalDate && (
                                <HelpBlock>
                                    <span className="text-danger">{errors.arrivalDate}</span>
                                </HelpBlock>
                            )}
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                        <Col componentClass={ControlLabel} sm={4} style={{ marginTop: 8 }}>
                            Unloading date
                        </Col>
                        <Col sm={8}>
                            {!isEditable && (
                                <p style={{ marginTop: 5 }}>
                                    {moment(unloadingDate).format('DD-MM-YYYY HH:mm') || '-'}
                                </p>
                            )}
                            {isEditable && (
                                <Datetime
                                    value={unloadingDate}
                                    onChange={handleDateChange('unloadingDate')}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat="HH:mm"
                                    inputProps={{ maxLength: 255 }}
                                    className={errors.unloadingDate && 'datetime-error'}
                                />
                            )}
                            {errors.unloadingDate && (
                                <HelpBlock>
                                    <span className="text-danger">{errors.unloadingDate}</span>
                                </HelpBlock>
                            )}
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col componentClass={ControlLabel} sm={4} style={{ marginTop: 10 }}>
                            Two way special?
                        </Col>
                        <Col sm={8}>
                            {!isEditable && (
                                <p style={{ marginTop: 5 }}>{twoWaySpecial ? 'Yes' : 'No'}</p>
                            )}
                            {isEditable && (
                                <Checkbox
                                    name="twoWaySpecial"
                                    checked={twoWaySpecial}
                                    onChange={handleChange}
                                    inline
                                />
                            )}
                        </Col>
                    </Row>
                </Col>
                <Col sm={4}>
                    <Row>
                        <Col componentClass={ControlLabel} sm={4}>
                            Impacted runs <br />
                            <small>(Route code - Run seq.)</small>
                        </Col>
                        <Col sm={8}>
                            {impactedRuns.length > 0
                                ? impactedRuns.map(run => <p key={run}>{run}</p>)
                                : 'N/A'}
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}

export default SpecialInfo;
